import media from "./media";

const theme = {
  media,
  colors: {
    primary: "#4B89E3",
    secondary: "#13192D",
  },
};

export default theme;
